
import { isEqual } from '@scripts/utilities/arrays.js';
import Feeds from '@scripts/utilities/feeds.js';

import AjaxService from '../Ajax/index.jsx';


var API = function(articleTypes, authors, bookmarked) {
  this.articleTypes = articleTypes;
  this.bookmarked = bookmarked;
  this.authors = authors;
  this.bookmarked = bookmarked;
  this.order = null;
  this.orderBy = null;
  this.terms = null;

  this._showLocked = true;
  this._fetchListeners = [];

  this._hideFreeArticles = false;
  this._hidePremiumArticles = false;

  this.handleResponse = this.handleResponse.bind(this);

  // add the common "Change Listener" functionality to this API
  Feeds.ChangeListener(this);
};
API.prototype.actionName = 'theme:content-feed';
API.prototype.addFetchListener = function(callback) {
  this._fetchListeners.push(callback);
};
API.prototype.removeFetchListener = function(callback) {
  for (var i = 0; i < this._fetchListeners.length; i++) {
    if (this._fetchListeners[i] == callback) {
      this._fetchListeners.splice(i, 1);
      break;
    }
  }
};

API.prototype.hideFreeArticles = function(hideFreeArticles) {
    this._hideFreeArticles = Boolean(hideFreeArticles);

    // notify the listeners that things have changed.
    this.notifyChangeListeners();
}

API.prototype.hidePremiumArticles = function(hidePremiumArticles) {
    this._hidePremiumArticles = Boolean(hidePremiumArticles);

    // notify the listeners that things have changed.
    this.notifyChangeListeners();
}

API.prototype.showLocked = function(showLocked) {
  this._showLocked = Boolean(showLocked);

  // notify the listeners that things have changed.
  this.notifyChangeListeners();
};
API.prototype.setArticleTypes = function(articleTypes) {
  this.articleTypes = articleTypes;

  this.notifyChangeListeners();
};
API.prototype.setOrder = function(order) {
  this.order = order;

  this.notifyChangeListeners();
};
API.prototype.setOrderBy = function(orderBy) {
  this.orderBy = orderBy;

  this.notifyChangeListeners();
};
API.prototype.setBookmarked = function(bookmarked) {
  this.bookmarked = bookmarked;

  this.notifyChangeListeners();
};
API.prototype.setAuthors = function(authors) {
  this.authors = authors;

  this.notifyChangeListeners();
};
// Set the bookmarked property of the API class
API.prototype.setBookmarked = function(bookmarked) {
  this.bookmarked = bookmarked;

  this.notifyChangeListeners();
};
API.prototype.setTerms = function(terms) {
  // exit early if we're not actually changing anything
  if (isEqual(terms, this.terms)) {
    return;
  }

  this.terms = terms;

  this.notifyChangeListeners();
};
API.prototype.fetchPage = function(page) {
  var data = {
    page: page,
    'show-locked': this._showLocked ? '1' : '0'
  };

  if (this.articleTypes && this.articleTypes.length) {
    data['article-types'] = this.articleTypes.join();
  }
  if (this.bookmarked) {
    data.bookmarked = this.bookmarked;
  }
  if (this.authors && this.authors.length) {
    data.authors = this.authors.join();
  }
  if (this.bookmarked) {
    data.bookmarked = this.bookmarked;
  }
  if (this.terms && this.terms.length) {
    data.terms = this.terms.join();
  }
  if (this.order) {
    data.order = this.order;
  }
  if (this.orderBy) {
    data['order-by'] = this.orderBy;
  }

  if (this._hideFreeArticles) {
    data['hide-free-articles'] = this._hideFreeArticles ? '1' : '0';
  }

  if (this._hidePremiumArticles) {
      data['hide-premium-articles'] = this._hidePremiumArticles ? '1' : '0';
  }

  // notify the listeners that we are fetching
  for (var i = 0; i < this._fetchListeners.length; i++) {
    this._fetchListeners[i](true);
  }

  return AjaxService.fetch(this.actionName, data)
    .then(this.handleResponse);
};
API.prototype.handleResponse = function(response) {
  // notify the listeners that we are finished fetching
  for (var i = 0; i < this._fetchListeners.length; i++) {
    this._fetchListeners[i](false);
  }

  if (response) {
    return response;
  } else {
    return [];
  }
};


export default API;

